import React from 'react';
import '../styles/Footer.css';

function Footer() {
  return (
    <div className="footer-wrapper">
      <footer className="footer">
        <div className="footer-content">
          <h2 className="footer-heading">Connect With Us</h2>
          
          <div className="social-links">
            <a 
              href="https://www.linkedin.com/company/nu-blockchain-group" 
              target="_blank" 
              rel="noopener noreferrer"
              className="social-button linkedin"
            >
              <i className="fab fa-linkedin"></i>
              Follow us on LinkedIn
            </a>
            
            <a 
              href="https://discord.gg/w6tUfpUMHn" 
              target="_blank" 
              rel="noopener noreferrer"
              className="social-button discord"
            >
              <i className="fab fa-discord"></i>
              Join our Discord
            </a>

            <a 
              href="https://instagram.com/nublockchain" 
              target="_blank" 
              rel="noopener noreferrer"
              className="social-button instagram"
            >
              <i className="fab fa-instagram"></i>
              Follow us on Instagram
            </a>
          </div>

          <div className="footer-bottom">
            <p>© {new Date().getFullYear()} NU Blockchain Group. All Rights Reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default Footer;